module.exports = __webpack_public_path__ + "img/mohamadElGhali2_lazy.32717dd8.png";